import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
const portalId = `${PortalIdParser.get()}`;

// Currently there's no dedicated endpoints for the onboarding beacon,
// Temporarily using the coaching tips endpoint for the experiment
const COACHING_TIPS_ENDPOINT_URL = '/coaching-tips/v1/status';
const requestPayload = {
  query: {
    portalId
  }
};
export const getOnboardingBeaconDismissStatus = onboardingBeaconId => http.get(`${COACHING_TIPS_ENDPOINT_URL}/${onboardingBeaconId}`, requestPayload).then(response => response.dismissed);
export const setOnboardingBeaconDismissStatus = onboardingBeaconId => http.post(`${COACHING_TIPS_ENDPOINT_URL}`, Object.assign({}, requestPayload, {
  data: {
    coachingTipId: onboardingBeaconId
  }
}));
export const restoreOnboardingBeacon = onboardingBeaconId => http.delete(`${COACHING_TIPS_ENDPOINT_URL}/${onboardingBeaconId}`, requestPayload);